import React from "react";
import { Door } from "./types";

interface DoorPanelProps {
  doors: Door[];
  handleAddDoor: () => void;
}

const DoorPanel: React.FC<DoorPanelProps> = ({ doors, handleAddDoor }) => (
  <div className="doorPanel">
    <div
      style={{
        display: "flex",
        justifyContent: "space-evenly",
        width: "27%",
        marginLeft: "2%",
        textAlign: "center",
      }}
    >
      <h1>Türbezeichnung</h1>
      <div className="buttonB" onClick={handleAddDoor}>
        <img
          src={"/img/configurator/plus.svg"}
          alt="plus"
          style={{ width: "20px", height: "20px", margin: "auto" }}
        />
      </div>
    </div>
    <p style={{ width: "10%", textAlign: "center"}}>Stück</p>
    <p style={{ width: "25%", textAlign: "left",marginLeft: "5%" }}>Zylindertyp</p>
    <div style={{ width: "17%", textAlign: "center", marginLeft:"5%", }}>
      <p>Länge in mm</p>
      <div>
        <p>außen</p>
        <p>innen</p>
      </div>
    </div>
  </div>
);

export default DoorPanel;
